function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChevronLeftIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M15.5521 20L7.46667 12L15.5521 4L16.8 5.44589L10.1762 12L16.8 18.5541L15.5521 20Z",
    fill: "currentColor"
  }));
}
export function ChevronLeftIconSmall(props) {
  return ___EmotionJSX(ChevronLeftIcon, _extends({
    size: "small"
  }, props));
}